import React from 'react';

import DownDistanceFilter from './DownDistanceFilter';
import FieldZoneFilter from './FieldZoneFilter';

function FootballPlayFilterPane() {
  return (
    <React.Fragment>
      <DownDistanceFilter />
      <FieldZoneFilter />
    </React.Fragment>
  );
}

export default FootballPlayFilterPane;
